export default "__VITE_ASSET__VhkYIQmi__"